import * as actionTypes from "../actionTypes";

export const getTransactionHistory = payload => ({
    type: actionTypes.GET_TRANSACTION_HISTORY,
    payload
})

export const setTransactionHistory = payload => ({
    type: actionTypes.SET_TRANSACTION_HISTORY,
    payload
})